export const ADMIN_GET_TASKS_REQUEST = "ADMIN_GET_TASKS_REQUEST";
export const ADMIN_GET_TASKS_SUCCESS = "ADMIN_GET_TASKS_SUCCESS";
export const ADMIN_GET_TASKS_FAILURE = "ADMIN_GET_TASKS_FAILURE";

export const ADMIN_ADD_TASK_REQUEST = "ADMIN_ADD_TASK_REQUEST";
export const ADMIN_ADD_TASK_SUCCESS = "ADMIN_ADD_TASK_SUCCESS";
export const ADMIN_ADD_TASK_FAILURE = "ADMIN_ADD_TASK_FAILURE";

export const ADMIN_UPDATE_TASK_REQUEST = "ADMIN_UPDATE_TASK_REQUEST";
export const ADMIN_UPDATE_TASK_SUCCESS = "ADMIN_UPDATE_TASK_SUCCESS";
export const ADMIN_UPDATE_TASK_FAILURE = "ADMIN_UPDATE_TASK_FAILURE";

export const ADMIN_DELETE_TASK_REQUEST = "ADMIN_DELETE_TASK_REQUEST";
export const ADMIN_DELETE_TASK_SUCCESS = "ADMIN_DELETE_TASK_SUCCESS";
export const ADMIN_DELETE_TASK_FAILURE = "ADMIN_DELETE_TASK_FAILURE";

export const ADMIN_SINGLE_TASK_REQUEST = "ADMIN_SINGLE_TASK_REQUEST";
export const ADMIN_SINGLE_TASK_SUCCESS = "ADMIN_SINGLE_TASK_SUCCESS";
export const ADMIN_SINGLE_TASK_FAILURE = "ADMIN_SINGLE_TASK_FAILURE";
